export default __webpack_public_path__ + "static/media/icon_clock.b2e8e1d4.svg";